import { TourRecommendationSearchViewModel } from '@api/models/TourRecommendationSearchViewModel';

import CarouselCard from './Carousel/CarouselCard';

type ICarouselProps = {
  data: TourRecommendationSearchViewModel[];
  earliestDepartureDate?: string;
  isExpedia?: boolean;
  setIsRedirecting?: (value: boolean) => void;
};

const CarouselCardNext = ({
  data,
  earliestDepartureDate,
  isExpedia,
  setIsRedirecting,
}: ICarouselProps) => {
  return (
    <CarouselCard
      isExpedia={isExpedia}
      data={data}
      earliestDepartureDate={earliestDepartureDate}
      setIsRedirecting={setIsRedirecting}
    />
  );
};

export default CarouselCardNext;
